import request from '../utils/request'

export function information(data) {
  return request({
    url: '/information/list',
    method: 'get',
    params: data
  })
}
// 资讯详情
export function informationId(noticeId) {
  return request({
    url: `/information/${noticeId}`
  })
}

// 企业预约POST http://localhost/user/make/order
export function userMakeOrder(data) {
  return request({
    url: '/user/make/order',
    method: 'post',
    data: data
  })
}
//行业类型字典
export function typeList(data) {
  return request({
    url: '/user/make/dict',
    method: 'get',
    params: data
  })
}